module.exports = __webpack_public_path__ + "img/tb-8.026c5f99.png";